import { Box, Typography, Popper, Alert, styled } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export const StyledContainer = styled(Box)({
  position: 'relative',
});

export const StyledUserButton = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

export const StyledUserNameText = styled(Typography)({
  color: 'white',
  fontWeight: 600,
  userSelect: 'none',
  maxWidth: 150,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const StyledDropdownIcon = styled(ArrowDropDownIcon, {
  shouldForwardProp: (prop) => prop !== 'isOpen',
})<{ isOpen: boolean }>(({ theme, isOpen }) => ({
  fontSize: 24,
  color: theme.palette.surface?.navItemInactive || '#9CA3AF',
  transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: theme.transitions.create('transform'),
}));

export const StyledPopper = styled(Popper)(({ theme }) => ({
  zIndex: theme.zIndex.modal,
}));

export const StyledSnackbarAlert = styled(Alert)({
  width: '100%',
});
